import { faFileDownload, faFileUpload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Authorization from '../../../Authentication/Authorization'
import DialogContext from '../../../Authentication/DialogContext'
import DataTable from '../../../components/DataTable'
import { EditDialogProps } from '../../../components/EditDialog'
import ProtectedButton from '../../../components/ProtectedButton'
import Loading from '../../../layout/Loading'
import SsoProxyService from '../../../service/SsoProxyService'

const SSOSProviderConfiguration = (props: any) => {
  const { t } = useTranslation()
  const { configurationStatus, setConfigurationStatus } = props
  const [spConfig, setSpConfig] = useState({} as any)
  const [loading, setLoading] = useState(true)
  const { editDialogPropsSetter } = useContext(DialogContext)

  useEffect(() => {
    async function loadData() {
      const spConfig = await SsoProxyService.getTargetSPInfo()
      setSpConfig(spConfig)
    }
    loadData().finally(() => setLoading(false))
  }, [])

  const columns = useMemo(() => {
    return [
      {
        text: 'label',
        dataField: 'label',
        classes: 'font-weight-bolder',
        sort: true,
      },
      {
        text: 'value',
        dataField: 'value',
        sort: true,
      },
    ]
  }, [])

  const data = getData()

  return (
    <Loading isLoading={loading}>
      <DataTable keyField='label' data={data} columns={columns} headerClasses='d-none' searchable={false} />
      <div className='text-right pr-1 ml-nfc-1'>
        <ProtectedButton variant='primary' className='ml-auto my-auto' onClick={importSPMetadata} permissions={Authorization.settings.ssoProxy.edit}>
          <FontAwesomeIcon icon={faFileUpload} />
          <span className='ml-1 my-auto'>{t('ssoProxy.importSPMetadata')}</span>
        </ProtectedButton>
        {configurationStatus.targetSPMetadataAvailable === true && (
          <ProtectedButton variant='primary' className='ml-auto my-auto' onClick={exportSPMetadata} permissions={Authorization.settings.ssoProxy.edit}>
            <FontAwesomeIcon icon={faFileDownload} />
            <span className='ml-1 my-auto'>{t('ssoProxy.exportSPMetadata')}</span>
          </ProtectedButton>
        )}
      </div>
    </Loading>
  )

  function getData() {
    if (spConfig.issuer === undefined) {
      return []
    }
    const assertionConsumerServices: any[] = spConfig.assertionConsumerServices?.map((entry: any) => {
      return {
        label: t('ssoProxy.assertionConsumerServices') + ' ' + entry.binding,
        value: entry.location,
      }
    })
    const singleLogoutService: any[] = spConfig.logoutServices?.map((entry: any) => {
      return {
        label: t('ssoProxy.singleLogoutService') + ' ' + entry.binding,
        value: entry.location,
      }
    })
    return [
      {
        label: t('ssoProxy.spName'),
        value: spConfig.issuer,
      },
      ...(assertionConsumerServices !== undefined ? assertionConsumerServices : []),
      ...(singleLogoutService !== undefined ? singleLogoutService : []),
    ]
  }

  function importSPMetadata() {
    const props: EditDialogProps = {
      show: true,
      header: t('ssoProxy.importSPMetadata'),
      onSubmit: SsoProxyService.uploadSPMetadata,
      onSubmitExtraArgs: [t, setSpConfig, setConfigurationStatus],
      labelGridSize: 5,
      submitText: t('import'),
      data: [
        {
          id: 'spMetadata',
          type: 'file',
          label: t('ssoProxy.sPMetadataFile'),
        },
      ],
    }

    editDialogPropsSetter(props)
  }

  function exportSPMetadata() {
    SsoProxyService.downloadGatewaySPMetadata()
  }
}

export default SSOSProviderConfiguration
